import React, { useEffect, useState } from "react";
import customerService from "../Services/customerService";
import toast from "react-hot-toast";
import ReceivableService from "../Services/receivableService";
import { useNavigate } from "react-router-dom";
import Dropdown from "../Components/Dropdown";
import orderService from "../Services/orderService"; 
import Select from "react-select";

const AddReceiveable = () => {
  const [customers, setCustomers] = useState([]);
  const [orders, setOrders] = useState([]); 

  const [data, setData] = useState({
    customer: "",
    number: "",
    bank: "",
    receiving: "",
    payable: "",
    amount: "",
    note: "",
    order_id: "",
  });

  const [errors, setErrors] = useState({
    customer: false,
    number: false,
    bank: false,
    receiving: false,
    payable: false,
    amount: false,
    note: false,
    order_id: false,
  });

  const [regex] = useState({
    customer: /.{1,50}$/,
    number: /.{1,50}$/,
    bank: /.{1,50}$/,
    receiving: /.{1,50}$/,
    payable: /.{1,50}$/,
    amount: /.{1,50}$/,
    note: /.{1,50}$/,
    order_id: /^.{1,50}$/,
  });

  const navigate = useNavigate();

  useEffect(() => {
    const getCustomers = async () => {
      try {
        const response = await customerService.fetchAll();
        setCustomers(response.customers);
      } catch (error) {
        console.log(error);
      }
    };
    getCustomers();
  }, []);

  const handleChange = async (e) => {
    const name = e.target?.name;
    const value = e.target?.value;

    setData((d) => ({ ...d, [name]: value }));
    setErrors((errs) => ({ ...errs, [name]: false }));

    // Fetch orders when customer changes
    if (name === "customer" && value) {
      try {
        const res = await orderService.fetchCustomerUnpaid(value);
        if (res?.orders) {
          setOrders(res.orders);
        } else {
          setOrders([]);
        }
      } catch (error) {
        toast.error("Failed to load customer orders");
        setOrders([]);
      }
    }
  };

  // Split a totalAmount across orders by their balances (in order)
function allocatePayments(orders, totalAmount) {
  let remaining = totalAmount;
  const allocations = [];

  for (const o of orders) {
    const bal = Number(o.balance) || 0;
    if (bal <= 0) continue;
    if (remaining <= 0) break;

    const pay = Math.min(bal, remaining);
    allocations.push({ orderId: o.id, pay });
    remaining -= pay;
  }

  const totalAllocated = allocations.reduce((s, a) => s + a.pay, 0);
  return { allocations, remaining, totalAllocated };
}


  // const submit = () => {
  //   let hasError = false;
  
  //   Object.keys(data).map((v) => {
  //     if (v === "order_id") return; // handled separately
  //     if (!regex[v]?.test(data[v])) {
  //       setErrors((prevState) => ({ ...prevState, [v]: true }));
  //       hasError = true;
  //     }
  //   });
  
  //   if (!Array.isArray(data.order_id) || data.order_id.length === 0) {
  //     setErrors((prevState) => ({ ...prevState, order_id: true }));
  //     hasError = true;
  //   }
  
  //   if (hasError) {
  //     toast.error("Please fill all the required fields");
  //     return;
  //   }
  
  //   // Create one payload per order
  //   const payloads = data.order_id.map((orderId) => {
  //     const order = orders.find((o) => o.id.toString() === orderId);
  //     return {
  //       ...data,
  //       order_id: orderId,
  //       amount: order?.balance || 0, // use order balance
  //     };
  //   });
  
  //   // Send each payload
  //   Promise.all(payloads.map((p) => ReceivableService.create(p)))
  //     .then(() => {
  //       toast.success("Receivables added successfully");
  //       navigate("/receiveable");
  //     })
  //     .catch((err) => {
  //       console.error(err);
  //       toast.error("Error adding receivables");
  //     });
  // };
  
  const submit = async () => {
    // Basic field validation
    let hasError = false;
  
    // Validate basic fields except order_id (multi) and amount (we’ll numeric-validate)
    Object.keys(data).forEach((v) => {
      if (v === "order_id" || v === "amount") return;
      if (!regex[v]?.test?.(data[v])) {
        setErrors((prev) => ({ ...prev, [v]: true }));
        hasError = true;
      }
    });
  
    // Validate selected orders
    const selectedIds = Array.isArray(data.order_id) ? data.order_id : [];
    if (selectedIds.length === 0) {
      setErrors((prev) => ({ ...prev, order_id: true }));
      hasError = true;
    }
  
    // Validate cheque amount (must be a positive number)
    const chequeAmount = Number(data.amount);
    if (!Number.isFinite(chequeAmount) || chequeAmount <= 0) {
      setErrors((prev) => ({ ...prev, amount: true }));
      hasError = true;
    }
  
    if (hasError) {
      toast.error("Please fill all the required fields correctly.");
      return;
    }
  
    // Build selected orders list and sum their balances
    const selectedOrders = selectedIds
      .map((id) => orders.find((o) => o.id.toString() === id))
      .filter(Boolean);
  
    if (selectedOrders.length === 0) {
      toast.error("No valid orders selected.");
      return;
    }
  
    const totalBalances = selectedOrders.reduce(
      (s, o) => s + (Number(o.balance) || 0),
      0
    );
  
    // If cheque > total balances, show your error and stop
const EPS = 0.000001; // handle tiny float errors
if (chequeAmount - totalBalances > EPS) {
  const totalStr = Number(totalBalances).toFixed(2);
  const chequeStr = Number(chequeAmount).toFixed(2);

  toast.error(
    `Please enter Cheque Amount less than or equal to the total of selected orders (Selected Orders Total: ${totalStr}, Cheque: ${chequeStr}). ` +
    `Either reduce the cheque amount or select another order.`
  );
  return; // ❌ don't submit
}

  
    // Allocate cheque across selected orders
    const { allocations, remaining, totalAllocated } = allocatePayments(
      selectedOrders,
      chequeAmount
    );
  
    if (totalAllocated <= 0) {
      toast.error("Nothing to allocate against the selected orders.");
      return;
    }
  
    // Create one receivable per allocation (partial payments allowed)
    try {
      await Promise.all(
        allocations.map((a) => {
          const order = selectedOrders.find((o) => o.id === a.orderId);
          const payload = {
            ...data,
            order_id: a.orderId.toString(),
            amount: Number(a.pay), // allocate
          };
          return ReceivableService.create(payload);
        })
      );
  
      if (remaining > 0) {
        // In theory shouldn’t happen because cheque <= totalBalances,
        // but we can keep a guard + friendly note
        toast(
          `Unallocated remainder ${remaining.toFixed(2)} (no eligible balances left).`,
          { icon: "ℹ️" }
        );
      }
  
      toast.success(
        `Receivables added: allocated ${totalAllocated.toFixed(
          2
        )} across ${allocations.length} order(s).`
      );
      navigate("/receiveable");
    } catch (err) {
      console.error(err);
      toast.error("Error adding receivables");
    }
  };
  


  return (
    <main className="mx-10 my-2 p-6 rounded-3xl border border-gray-200 shadow-lg mb-20 bg-white">
      <p className="font-bold text-3xl text-secondary">New Add Receivable</p>

      <div className="mt-10">
        <div className="grid grid-cols-2 gap-2 md:grid-cols-4 md:gap-8">
          <div className="col-span-2">
            <label className="primary-label">Customer</label>
            <Dropdown
              style="!col-span-2"
              selected={data.customer}
              placeholder="Select Customer"
              onChange={(value) =>
                handleChange({ target: { name: "customer", value } })
              }
              options={customers.map((customer) => ({
                label: customer.company_name,
                value: customer.id,
              }))}
            />
          </div>

          <div>
            <label className="primary-label">Cheque No.</label>
            <input
              name="number"
              onChange={(e) => handleChange(e)}
              placeholder="Cheque No."
              className={`primary-input ${errors["number"] ? "!border-red-600" : ""}`}
            />
          </div>
          <div>
            <label className="primary-label">Bank Name</label>
            <input
              name="bank"
              onChange={(e) => handleChange(e)}
              placeholder="Bank Name"
              className={`primary-input ${errors["bank"] ? "!border-red-600" : ""}`}
            />
          </div>
        </div>

        {/*4. Customer Orders Select */}
        {/* Customer Orders Select - Multi */}
        {/* Customer Orders Select - Multi (No Open Order) */}
        <div className="grid grid-cols-2 gap-2 md:grid-cols-4 md:gap-8 mt-4">
          <div className="col-span-2">
            <label className="primary-label">Customer Orders (Unpaid)</label>
            <Select
              isMulti
              options={orders.map((order) => ({
                label: `Order #${order.id} - Balance: ${order.balance}`,
                value: order.id.toString(),
              }))}
              value={
                Array.isArray(data.order_id)
                  ? data.order_id.map((id) => {
                    const order = orders.find((o) => o.id.toString() === id);
                    return {
                      label: `Order #${order?.id} - Balance: ${order?.balance}`,
                      value: id,
                    };
                  })
                  : []
              }
              onChange={(selected) => {
                const selectedValues = selected.map((s) => s.value);
                setData((d) => ({ ...d, order_id: selectedValues }));
              }}
              placeholder="Select Order(s)"
            />
          </div>
        </div>



        <div className="grid grid-cols-2 gap-2 md:grid-cols-3 md:gap-8 mt-4">
          <div>
            <label className="primary-label">Amount</label>
            <input
              name="amount"
              type="number"
              onChange={(e) => handleChange(e)}
              placeholder="Amount"
              className={`primary-input ${errors["amount"] ? "!border-red-600" : ""}`}
            />
          </div>
          <div>
            <label className="primary-label">Receiving Date</label>
            <input
              name="receiving"
              onChange={(e) => handleChange(e)}
              type="date"
              className={`primary-input ${errors["receiving"] ? "!border-red-600" : ""}`}
            />
          </div>
          <div>
            <label className="primary-label">Presentable Date</label>
            <input
              name="payable"
              onChange={(e) => handleChange(e)}
              type="date"
              className={`primary-input ${errors["payable"] ? "!border-red-600" : ""}`}
            />
          </div>
        </div>

        <div className="grid grid-cols-1 mt-4">
          <div>
            <label className="primary-label">Note</label>
            <textarea
              name="note"
              onChange={(e) => handleChange(e)}
              placeholder="Note"
              className={`primary-input ${errors["note"] ? "!border-red-600" : ""}`}
            />
          </div>
        </div>

        <div className="flex items-center justify-center mt-12">
          <button onClick={submit} className="button-primary">
            Add Receivable
          </button>
        </div>
      </div>
    </main>
  );
};

export default AddReceiveable;